export default function HowToPurchaseData() {
    return {
        title: 'How to Purchase',
        paragraphs: [`<div>Contact LTCI Partners for further education as well as to review solutions available for your client (product/carrier questions, quick quotes, illustrations, etc.):<div>`,
        `<br/><div>P: <a href='tel:855-219-6568'>855-219-6568</a></div>`,
        `<br/><div><a href='mailto:MORGAN.STANLEY@LTCIPARTNERS.COM'>MORGAN.STANLEY@LTCIPARTNERS.COM</a></div>`
        ],
    }
}


// WEBPACK FOOTER //
// ./src/components/Common/data/products/traditional-long-term-care/HowToPurchaseData.js